export default __webpack_public_path__ + "static/media/System-Break.9af84c6b.svg";